import { type PostFilter } from "@package/ui-gql/index-data-access";
import { type WritableDraft } from "immer";
import { useItemGridFilterContext } from "../ItemGridFilter/context-item-grid-filter";
import { ItemGridFilterBoolean } from "../ItemGridFilter/ItemGridFilterBoolean";

type SupportedFilter = PostFilter | null | undefined;

export function ItemGridFilterHideSearch() {
  const { filter, updateFilterState } = useItemGridFilterContext();

  const filterWithHideSearch: SupportedFilter = filter;

  return (
    <ItemGridFilterBoolean
      checked={filterWithHideSearch?.hideFromSearch ?? undefined}
      property="hideFromSearch"
      text="Hide from Search"
      onRequestFilterReset={() =>
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            delete draft.hideFromSearch;
          }
        })
      }
      onRequestFilterUpdate={() =>
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            if (filterWithHideSearch?.hideFromSearch === true) {
              draft.hideFromSearch = false;
            } else if (filterWithHideSearch?.hideFromSearch === false) {
              delete draft.hideFromSearch;
            } else {
              draft.hideFromSearch = true;
            }
          }
        })
      }
    />
  );
}
